export default __webpack_public_path__ + "01d661e0798fc21d95b7f635a552838c.png";